<template>
  <a-card :bordered="false">
    <p v-if="!showPage">功能未开通</p>
    <div v-if="showPage">
      <!-- 表格筛选 start -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @submit="handleSubmit">
          <a-row :gutter="48">
            <!-- 输入关键词查找 -->
            <a-col :md="6" :sm="24">
              <a-form-item label="开始日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-date-picker :disabled-date="disabledDate" :default-value="moment(queryParam.stime, dateFormat)" @change="onChange" />
              </a-form-item>
            </a-col>
            <template v-if="advanced">
            </template>
            <!-- 展开或者收起筛选项 start -->
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleSubmit">刷新</a-button>
              </span>
            </a-col>
            <!-- 展开或者收起筛选项 end -->
          </a-row>
        </a-form>
      </div>
      <!-- 表格筛选 end -->
      <!-- 表格内容操作 start -->
      <div class="table-operator">
      </div>
      <!-- 表格内容操作 end -->
      <!-- 表格 start -->
      <a-spin v-if="loading" />
      <div class="table-wrapper" v-if="!loading">
        <div class="ant-table-wrapper">
          <div class="ant-table ant-table-fixed-header ant-table-scroll-position-left ant-table-middle ant-table-layout-fixed ant-table-default">
            <div class="ant-table-content">
              <div class="ant-table-scroll">
                <div class="ant-table-header" style="margin-bottom:0px;padding-bottom:0px;min-width: 0px; overflow: hidden hidden;">
                  <table class="ant-table-fixed">
                    <!-- <colgroup>
                    <col><col><col><col><col><col>
                    </colgroup> -->
                    <thead class="ant-table-thead">
                      <tr>
                        <th style="width:100px;text-align:center;">
                          <div>
                            日期/时段
                          </div>
                        </th>
                        <th v-for="(day, index) in data.days" :key="index">
                          <div style="text-align:center;">
                            {{ day.day }}<br/>{{ day.week }}
                          </div>
                        </th>
                      </tr>
                    </thead>
                  </table>
                </div>
                <div class="ant-table-body" style="max-height: 500px; overflow-y: scroll;">
                  <table class="ant-table-bordered">
                    <colgroup>
                      <col><col><col><col><col><col>
                    </colgroup>
                    <tbody class="ant-table-tbody">
                      <tr v-for="(times, index) in data.arr" :key="index" class="ant-table-row" style="text-align:center">
                        <td style="width:100px;text-align:center;">{{ times.time }}</td>
                        <td v-for="(state, ii) in times.data" :key="ii">
                          <!-- close -->
                          <a-button @click="changePlan(state)" v-if="state.state === 'close'" size="small" class="close_btn">CLOSE</a-button>
                          <!-- booked -->
                          <a-button v-if="state.state === 'booked'" size="small" disabled class="booked_btn">BOOKED</a-button>
                          <!-- open -->
                          <a-button @click="changePlan(state)" v-if="state.state === 'open'" size="small" class="open_btn">OPEN</a-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 表格 end -->
    </div>
  </a-card>
</template>
<script>
import moment from 'moment'
import { feijiaoPlan, changePlan } from '@/api/plan'
import { TcgTable } from '@/components'
import _ from 'lodash'
import { getUserInfo } from '@/api/account'

export default {
  components: {
    TcgTable
  },
  data () {
    this.dateFormat = 'YYYY-MM-DD'
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18,
        offset: 1
      },
      // 时间
      time: [],
      // 查看抽屉状态开关
      viewVisible: false,
      // id
      id: '',
      // 字典
      dict: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        stime: moment().format(this.dateFormat)
      },
      data: {
        arr: [],
        fjtime: []
      },
      loading: false,
      changeData: {},
      showPage: true
    }
  },
  created () {
    this.handelPre()
    this.handleSubmit()
  },
  methods: {
    handelPre () {
      // 获取用户信息
      getUserInfo().then(response => {
        const classifcation = _.get(response, 'data.classifcation', [])
        console.log(classifcation)
        const fj= classifcation.findIndex(item => item=== '菲教')
        if (fj === -1) {
          this.showPage = false
        }
      })
    },
    moment,
    // 重置按钮
    reset () {
      this.queryParam = {
        stime: ''
      }
    },
    disabledDate(current) {
      return current && current < moment().subtract(1, 'days')
    },
    onChange(date, dateString) {
      if (dateString !== '') {
        this.queryParam.stime = dateString
        this.handleSubmit()
      }
    },
    changePlan (record) {
      this.changeData = {
        'times': record.time,
        'days': record.day,
        'type': record.state,
        'plantype': this.data.classifcation
      }
      console.log(this.changeData)
      changePlan(this.changeData).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('操作成功')
          let changeState = 'open'
          if (record.state === 'open') {
            changeState = 'close'
          }
          record.state = changeState
        }
      })
    },
    // 提交筛选
    handleSubmit () {
      this.loading = true
      feijiaoPlan(this.queryParam).then(res => {
        if (_.get(res, 'code') === 200) {
          this.data = _.get(res, 'values', {})
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .close_btn {
    background:#e6e6e6;
    color:#000000;
  }
  .close_yy_btn {
    background:#e6e6e6;
    color:#000000;
    margin-right:5px;
  }
  .open_btn {
    background-color: #3bb4f2;
    color:#3bb4f2;
    border-color:#3bb4f2;
    color:#ffffff;
  }
  .open_yy_btn {
    background-color: #3bb4f2;
    color:#3bb4f2;
    border-color:#3bb4f2;
    color:#ffffff;
    margin-right:5px;
  }
  .booked_btn {
    background:#5eb95e;
    color:#ffffff;
    border-color:#5eb95e;
  }
  .booked_yy_btn {
    background:#5eb95e;
    color:#ffffff;
    border-color:#5eb95e;
    margin-right:5px;
  }
</style>
